import './AdminRoleReport.css';
import PropTypes from 'prop-types';

const AdminRoleReport = ({ orders, loading, selectedOrder, selectedOrderDetails }) => {
  // ✅ Extract order status safely
  const testStatus = selectedOrderDetails?.db_order?.status_detail?.label || 'N/A';
  const isTestComplete = testStatus === 'Test Complete' || 'Order Processing';

  return (
    <div className="admin-report-container">
      {/* <button className="back-button" onClick={onBack}>
        ← Back
      </button> */}
      {/* <h1 className="admin-report-title">Admin Report Dashboard</h1> */}

      {loading ? (
        <p>Loading orders...</p>
      ) : orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <>
          {/* --- Orders Table --- */}
          {/* <table className="admin-orders-table">
            <thead>
              <tr>
                <th>Order #</th>
                <th>Customer</th>
                <th>Email</th>
                <th>Status</th>
                <th>Total ($)</th>
                <th>Date</th>
                <th>Has Report?</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => {
                const hasParsedData = !!order?.db_order?.pdf_documents?.[0]?.parsed_data?.length;
                return (
                  <tr key={order.id}>
                    <td>#{order.order_number}</td>
                    <td>
                      {order.customer?.first_name} {order.customer?.last_name}
                    </td>
                    <td>{order.email}</td>
                    <td>{order.db_order?.status_detail?.label || 'Processing'}</td>
                    <td>{order.total_price}</td>
                    <td>{new Date(order.created_at).toLocaleDateString()}</td>
                    <td>
                      <span className={`badge ${hasParsedData ? 'badge-yes' : 'badge-no'}`}>{hasParsedData ? 'Report Available' : 'No Report'}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table> */}

          {/* --- Dropdown --- */}
          {/* <div className="admin-dropdown-container">
            <label>Select an Order:</label>
            <select value={selectedOrder} onChange={handleOrderChange}>
              <option value="">-- Select Order --</option>
              {orders.map((order) => (
                <option key={order.id} value={String(order.order_number)}>
                  #{order.order_number}
                </option>
              ))}
            </select>
          </div> */}

          {/* --- Order Status Message (only if not complete) --- */}
          {selectedOrder && !isTestComplete && (
            <div className="order-status-message status-processing">🧪 This order’s test is still processing. Please check back later.</div>
          )}

          {/* --- Parsed Report (only if Test Complete) --- */}
          {isTestComplete && selectedOrderDetails?.db_order?.pdf_documents?.[0]?.parsed_data?.length > 0 && (
            <div className="parsed-data-section">
              <h2>Parsed Report Data</h2>
              {selectedOrderDetails.db_order.pdf_documents.map((doc, idx) => (
                <div key={idx} className="pdf-block">
                  {/* <h3>{doc.title}</h3> */}
                  {doc.parsed_data.map((p, pIdx) => {
                    const testHistory = p.data?.testHistory || [];
                    return (
                      <div key={pIdx} className="parsed-item">
                        {/* <h4>Patient: {p.data?.name}</h4> */}
                        {testHistory.map((t, tIdx) => (
                          <div key={tIdx} className="test-history-block">
                            {/* <p>
                              <strong>Date:</strong> {t.date}
                            </p> */}
                            {/* <p>
                              <strong>Overall Score:</strong> {t.overallScore}
                            </p> */}

                            {/* Table for categories */}
                            <table className="category-table">
                              <thead>
                                <tr>
                                  <th>Category</th>
                                  <th>Metric</th>
                                  <th>Value</th>
                                  <th>Unit</th>
                                  <th>Reference</th>
                                  {/* <th>Status</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {Object.values(t.categories || {}).map((cat) =>
                                  cat.metrics.map((metric, mIdx) => (
                                    <tr key={mIdx}>
                                      <td>{cat.name}</td>
                                      <td>{metric.name}</td>
                                      <td>{metric.value}</td>
                                      <td>{metric.unit}</td>
                                      <td>{metric.referenceRange}</td>
                                      {/* <td>{metric.status}</td> */}
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

AdminRoleReport.propTypes = {
  orders: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  selectedOrder: PropTypes.string,
  handleOrderChange: PropTypes.func.isRequired,
  selectedOrderDetails: PropTypes.object,
  onBack: PropTypes.func.isRequired,
};

export default AdminRoleReport;
